import styled from "styled-components";

export const Cards = styled.div(() => ({
  display: "flex",
  margin: "auto",
  marginTop: "80px",
  maxWidth: "1440px",
  justifyContent: "center",
  alignItems: "center",
  "@media (max-width: 768px)": {
    flexDirection: "column",
  },
}));
export const Card = styled.div(() => ({
  margin: "40px 0px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  alignSelf: "flex-start",
  width: "25%",
  p: {
    color: "#005ca7",
    fontWeight: 700,
    width: "60%",
    textAlign: "center",
  },
  img: {
    height: "200px",
    cursor: "pointer",
  },
  "@media (max-width: 768px)": {
    alignSelf: "center",
    width: "50%",
    margin: "0 0 40px 0",
    p: {
      width: "65%",
      minWidth: "172px",
    },
  },
}));
